
import Component from 'vue-class-component';
import Vue from 'vue';
import AuthHeader from '@/components/layouts/AuthHeader.vue';

@Component({
  name: 'LayoutAuth',
  components: { AuthHeader },
})
export default class LayoutAuth extends Vue {}
